import React from 'react';
import { BusinessJourneyData, BusinessJourneyLayout } from './graph/model';
import { BusinessJourneyPresentationView } from './graph/BusinessJourneyPresentationView';

type Props = {
  businessJourneyData: BusinessJourneyData;
  layout?: BusinessJourneyLayout;
};

export function BusinessJourneyComponent({ layout = 'horizontal', businessJourneyData }: Props) {
  return <BusinessJourneyPresentationView layout={layout} businessJourneyData={businessJourneyData} />;
}
